const TargetIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <circle
                cx="11.7929"
                cy="12.707"
                r="3.07829"
                transform="rotate(-45 11.7929 12.707)"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.185 10.4287C19.6951 12.0836 19.6351 13.8617 19.0146 15.4785C18.3942 17.0952 17.2492 18.457 15.7629 19.3458C14.2767 20.2346 12.5352 20.599 10.8173 20.3806C9.09945 20.1622 7.50453 19.3737 6.28794 18.1414C5.07136 16.909 4.30349 15.304 4.10728 13.5835C3.91107 11.8629 4.29788 10.1263 5.20577 8.65161C6.11366 7.17697 7.49011 6.04962 9.11473 5.45008C10.7393 4.85053 12.5182 4.81347 14.1663 5.34483"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8606 12.6602L16.189 8.33201M16.189 8.33201L16.189 6.21069L18.3103 4.08937V6.21069H20.4316L18.3103 8.33201L16.189 8.33201Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default TargetIcon
